import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import EN from "./dictionary/en.json";
import DE from "./dictionary/de.json";
import FR from "./dictionary/fr.json";
import AE from "./dictionary/ae.json";

// Language code mapping (internal codes -> ISO 639-1 codes)
export const languageMap = {
  en: "en",
  de: "de",
  fr: "fr",
  ae: "ar", // Arabic
};

// Get HTML lang attribute from language code
export const getHtmlLang = (languageCode) => {
  return languageMap[languageCode] || "en";
};

// Detect browser language and return supported language code
const detectBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  const langCode = browserLang.split("-")[0].toLowerCase();

  // Map browser language codes to our supported languages
  const browserLangMap = {
    en: "en",
    de: "de",
    fr: "fr",
    ar: "ae",
  };

  return browserLangMap[langCode] || "en";
};

// Get initial language: localStorage > browser detection > default
const getInitialLanguage = () => {
  const saved = localStorage.getItem("language");

  if (saved && ["en", "de", "fr", "ae"].includes(saved)) {
    return saved;
  }

  // Try to detect user's browser language
  const detected = detectBrowserLanguage();
  localStorage.setItem("language", detected);
  return detected;
};

const savedLanguage = getInitialLanguage();

// Apply initial language settings to DOM
const applyLanguageToDom = (lang) => {
  document.documentElement.lang = getHtmlLang(lang);

  if (lang === "ae") {
    document.documentElement.dir = "rtl";
    document.body.style.direction = "rtl";
  } else {
    document.documentElement.dir = "ltr";
    document.body.style.direction = "ltr";
  }
};

// Set initial HTML lang attribute and direction
applyLanguageToDom(savedLanguage);

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: EN,
    },
    de: {
      translation: DE,
    },
    fr: {
      translation: FR,
    },
    ae: {
      translation: AE,
    },
  },
  lng: savedLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

// Persist language changes to localStorage and update DOM
i18n.on("languageChanged", (lng) => {
  // Save to localStorage for persistence
  localStorage.setItem("language", lng);

  // Apply language settings to DOM
  applyLanguageToDom(lng);

  // Dispatch custom event for components to listen to
  window.dispatchEvent(
    new CustomEvent("languageChanged", { detail: { language: lng } }),
  );
});

export default i18n;
